import React, { Component } from 'react';

import { connect } from 'react-redux';

import * as Employees from 'employees/components';
import EmployeeFormHandlers from 'employees/containers/EmployeeFormHandlers';

import { getIsSaving, getIsFetching, getEditing, getIsFetchingConfig } from 'employees/selectors';
import { getVisibleCustomFieldsEmployees } from 'custom_fields_employees/selectors';
import { getVisibleGroups } from 'groups/selectors';
import { getCompany, getSubcompany } from 'auth/selectors';

class EmployeesFormContainer extends Component {
  render = () => (
    <EmployeeFormHandlers
      render={({
        handleAddYear, //no se usa
        handleRemoveYear, //no se usa
        handleSubmit,
        handleValidation,
        handleValueChange,
        handleCustomFieldChange,
        handleGroupChange,
        isSubmitted,
        isSaving,
        activeImage,
        onDragEnter,
        onDragLeave,
        handleFileSelected,
      }) => (
        <Employees.FormView
          company={this.props.company}
          employee={this.props.employee}
          customfields={this.props.customfields}
          handleAddYear={handleAddYear}
          handleRemoveYear={handleRemoveYear}
          handleSubmit={handleSubmit}
          handleValidation={handleValidation}
          handleValueChange={handleValueChange}
          isFetching={this.props.isFetching}
          isSubmitted={isSubmitted}
          isSaving={isSaving}
          subcompany={this.props.subcompany}
          handleGroupChange={handleGroupChange}
          handleCustomFieldChange={handleCustomFieldChange}
          groups={this.props.groups}
          activeImage={activeImage}
          onDragEnter={onDragEnter}
          onDragLeave={onDragLeave}
          handleFileSelected={handleFileSelected}
        />
      )}
    />
  );
}

const mapStateToProps = (state) => ({
  isSaving: getIsSaving(state),
  isFetching: getIsFetching(state),
  isFetchingConfig: getIsFetchingConfig(state),
  employee: getEditing(state),
  customfields: getVisibleCustomFieldsEmployees(state),
  groups: getVisibleGroups(state),
  company: getCompany(state),
  subcompany: getSubcompany(state),
});

export default connect(mapStateToProps, null)(EmployeesFormContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/employees/containers/EmployeeFormContainer.js